import jwtDecode, {JwtPayload} from "jwt-decode";
import moment from "moment";

export const getJwtExpMoment = (token: string) => {
    const decoded = jwtDecode<JwtPayload>(token);
    const exp = decoded.exp;
    return moment.unix(exp)
}

export const decodeJwt = (token: string) => {
    const parts = token.split('.');

    function base64UrlDecode(base64Url: string) {
        base64Url = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        while (base64Url.length % 4) {
            base64Url += '=';
        }
        return JSON.parse(atob(base64Url));
    }

    const header = base64UrlDecode(parts[0]);
    const payload = base64UrlDecode(parts[1]);

    return {
        header,
        payload,
    };
}